import React, { useEffect, useState } from "react";
import {
  deleteRestaurant,
  getAllRestaurants,
} from "../../../api/restaurants.api";
import AdminLayout from "../../layout/AdminLayout";
import { BsTrash3 } from "react-icons/bs";
import { Link } from "react-router-dom";
import {
  confirmRestaurantDelete,
  errorMsg,
  success,
} from "../../../utils/notifications";
import { FiPlus } from "react-icons/fi";
import { RotatingLines } from "react-loader-spinner";

function Restaurants() {
  const [restaurantDetails, setRestaurantDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllRestaurants()
      .then((res) => {
        // Log the full response to check the structure of res.data
        console.log("Full Response:", res);

        if (res?.data) {
          setRestaurantDetails(res.data); // Ensure res.data is an array
          setLoading(false);
          console.log("Restaurant Details:", res.data); // Log the restaurant data
        } else {
          console.error("No restaurant data received.");
          setRestaurantDetails([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  }, []);

  const handleDelete = (id, e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      confirmRestaurantDelete().then(async (result) => {
        if (result.isConfirmed) {
          await deleteRestaurant(id);
          setRestaurantDetails(
            restaurantDetails.filter((restaurant) => restaurant._id !== id)
          );
          await success("Success!", "Fixed Location deleted successfully!");
        }
      });
    } catch (error) {
      console.error("Error deleting restaurant:", error);
      errorMsg("Oops", error?.response?.message);
    }
  };

  return (
    <AdminLayout title="Fixed Locations">
      <div className="p-5">
        <div className="mb-5 flex items-center justify-end sticky top-16 bg-slate-50 py-3 z-10 px-2">
          <Link
            to="/fixedLocations/add"
            className="flex items-center justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
          >
            <FiPlus className="text-lg text-gray-700" />
            Add Fixed Location
          </Link>
        </div>
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <RotatingLines
              strokeColor="black"
              strokeWidth="5"
              animationDuration="0.75"
              width="96"
              visible={true}
            />
          </div>
        ) : (
          <div className="gap-7 grid grid-cols-12">
            {restaurantDetails.length === 0 ? (
              <p className="col-span-12 text-center text-xl font-bold text-gray-600">
                No restaurants found.
              </p>
            ) : (
              restaurantDetails.map((restaurant, index) => (
                <Link
                  to={`/fixedLocations/${restaurant._id}`}
                  key={index}
                  className="lg:col-span-4 md:col-span-12 col-span-12"
                >
                  <div className="bg-white border border-gray-200 rounded-lg shadow">
                    <div className="px-5 py-3 flex items-center justify-end">
                      <button
                        onClick={(e) => handleDelete(restaurant._id, e)}
                        className="ml-3 text-xl h-8 w-8 flex items-center justify-center bg-red-100 text-red-700 px-0.5 rounded-md"
                      >
                        <BsTrash3 />
                      </button>
                    </div>
                    <div className="py-5">
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-xl font-semibold text-gray-700">
                          {restaurant.name}
                        </p>
                      </div>
                      <div className="px-5 pb-1 mt-1 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-700">
                          Location
                        </p>
                        <p className="text-base font-semibold text-gray-600">
                          {restaurant.location}
                        </p>
                      </div>
                      <div className="px-5 flex justify-between my-1">
                        <h1 className="text-gray-600 font-semibold text-base">
                          Cuisine Type
                        </h1>
                        <span className="text-sm font-medium text-gray-600">
                          {restaurant.cuisineType}
                        </span>
                      </div>
                      <div className="px-5 flex justify-between my-1">
                        <h1 className="text-gray-600 font-semibold text-base">
                          Status
                        </h1>
                        <span
                          className={`text-sm font-medium ${
                            restaurant.status === "Pending Approval"
                              ? "text-red-500"
                              : "text-green-500"
                          }`}
                        >
                          {restaurant.status}
                        </span>
                      </div>

                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Seating Capacity
                        </p>
                        <p className="text-sm font-normal text-gray-600">
                          {restaurant.seatingCapacity}
                        </p>
                      </div>
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Foot Traffic Estimate
                        </p>
                        <p className="text-sm font-normal text-gray-600">
                          {restaurant.footTrafficEstimate}
                        </p>
                      </div>
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Phone
                        </p>
                        <p className="text-sm font-normal text-gray-600">
                          {restaurant.contactInformation.phone}
                        </p>
                      </div>
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Email
                        </p>
                        <p className="text-sm font-normal text-gray-600">
                          {restaurant.contactInformation.email || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            )}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}

export default Restaurants;
